import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';

import { delayMethod } from '../../services/utils';

const OtherRequestTypeShow = ({ otherRequestType, hideModal }) => {
  const { name, isActive } = otherRequestType;

  return (
    <>
      <Modal.Body>
        <Row>
          <Col md={12}>
            <strong>Nombre:</strong> {name}
          </Col>
          <Col md={12} className="mt-2">
            <strong>Estado:</strong> {isActive ? 'Activo' : 'Inactivo'}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-info" onClick={() => delayMethod(hideModal)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </>
  );
};

export default OtherRequestTypeShow;